<template>
  <v-alert
    v-model="show"
    :color="options.color"
    variant="outlined"
    rounded="0"
    :icon="false"
    :style="
      `background-color: ${options.backgroundColor};
       width: ${options.width && !$vuetify.display.mobile ? options.width : '100%'};
       ${options.borderColor ? 'border-color: ' + options.borderColor + ';' : ''};
       z-index: 12;
       ${options.positionFixed ? 'position: fixed; left: 50%; transform: translate(-50%, -50%);' : 'position: relative;' }`
    "
    :class="['py-2 px-4 d-block mx-auto', options.class ? ` ${options.class}` : ' mt-md-14 mt-0']"
  >
  <div class="d-flex" width="100">
    <v-icon :color="options.iconColor" class="mt-1" size="24" :icon="options.icon"></v-icon>
    <v-alert-title class="mx-2 title text-left">
      <div v-if="title" v-html="title"></div>
    </v-alert-title>
    <v-btn flat icon color="transparent" size="x-small" class="ml-auto" @click="close">
      <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
    </v-btn>
  </div>
    
    <div :class="['text-left mx-8 message', message || options.link ? 'mb-3' : '']">
      <div class="mt-4" v-if="message" v-html="message"></div>
      <v-btn
        v-if="options.link"
        color="primary"
        flat
        variant="plain"
        height="40"
        class="mt-4 font-weight-medium button"
        rounded
        @click="$router.push({
          ...(options.linkQuery) && {query: {selected: options.linkQuery}},
          ...{name: options.linkRouteName}
        })"
      >
        {{options.linkText}}
      </v-btn>
      <v-btn
        v-if="options.action"
        flat
        height="40"
        :width="this.$vuetify.display.mobile ? '100%' : 'auto'"
        color="primary"
        rounded
        class="mt-4 py-4 px-6 d-flex align-center button"
        @click="options.actionCallback">
          <div class="button_wrapper d-flex align-center">
            <v-icon :icon="options.actionIcon" class="mr-4" color="white" size="24"></v-icon>
            <div>{{options.actionText}}</div>
          </div>
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  data: () => ({
    visible: false,
    message: null,
    title: null,
    options: {
      positionFixed: false,
      class: null,
      color: 'rgba(248, 203, 121, 1)',
      backgroundColor: 'rgb(254,245,228)',
      icon: 'mdi-information-outline',
      iconColor: 'rgba(249, 193, 0, 1)',
      link: false,
      linkText: null,
      linkRouteName: null,
      linkQuery: null,
      timeout: false,
      timeoutDuration: 0,
      action: false,
      actionCallback: null,
      actionIcon: null,
      actionText: null
    },
    timeoutHandler: null
  }),
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        this.visible = value
      }
    }
  },
  methods: {
    showAlert(title, message, options) {
      this.visible = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if(this.options.timeout) {
          this.timeoutHandler = setTimeout(() => {
            this.show = false;
            clearTimeout(this.timeoutHandler);
          }, this.options.timeoutDuration)
        }
      })
    },
    close() {
      this.show = false;
      clearTimeout(this.timeoutHandler);
    },
  },
  watch: {
    $route (to, from) {
      if (to != from && this.visible) {
        this.visible = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .message {
    p, .v-btn {
      font-size: 14px !important;
      line-height: 21px !important;
    }
  }
  // helper classes for title and message html
  .header {
    padding: 0;
    margin: 0;
    @include nsb-font-header;
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .subheader {
    @include nsb-font-label;
    font-size: 12px !important;
    line-height: 18px !important;
  }
  .subdata {
    @include nsb-font-label;
  }
  .card {
    background-color: rgba(255, 255, 255, 0.4);
  }
  .button {
    @include nsb-font-button-medium;
    border: 1px solid $ds-primary !important;
    color: $ds-primary;
    font-weight: 500 !important;
  }
  :deep(.link) {
    font-weight: bold;
    text-decoration: underline;
  }
</style>

<style lang="scss" scoped>
  .v-alert__content {
    width: 100%;
    .v-alert-title {
      @include nsb-gentium-bold;
      color: $ds-primary;
      font-size: 23px;
      line-height: 27px;
    }
  }
</style>